import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { reactive, computed, onMounted } from 'vue'
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons-vue';
import { postUserApi, postUserLogin } from '@/servers/api/user';
import { getStudentApi } from '@/servers/api/student';
import router from '@/router';
import { useUserStore } from '@/store';
import { message } from 'ant-design-vue';
import { useSchoolSelection } from '@/composables/useSchoolSelection';

// 使用共用的学校/年级/班级选择逻辑
interface FormParams {
  email: string
  password: string
  name: string
  schoolName: string
  schoolId: string
  grade: string
  classId: number
  stuName: string
  role: string
}

// 扩展的绑定状态类型，包含uid
interface ExtendedBindStatus {
  id: string
  school: string
  class_id: string
  stuName: string
  uid: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const {
  schoolList,
  gradeList,
  classList,
  fetchGradesBySchool,
  fetchClassesByGrade,
  loadSchoolData,
} = useSchoolSelection();

// 表单参数
const disabled = computed(() => {
  return !(formparams.email && formparams.password && formparams.name && formparams.schoolId && formparams.grade && formparams.classId && formparams.stuName);
});

const formparams = reactive<FormParams>({
  email: '',
  password: '',
  name:'',
  schoolName: '',
  schoolId: '',
  grade: '',
  classId: 0,
  stuName: '',
  role:''
})

const userStore = useUserStore();

// 学校选择事件处理
const handleSchoolChange = async (value: string) => {
  formparams.schoolId = value;
  // 同时保存学校名称用于后续绑定
  const selectedSchool = schoolList.value.find(s => s.school_id === value);
  formparams.schoolName = selectedSchool ? selectedSchool.name : '';
  formparams.grade = '';
  formparams.classId = 0;
  formparams.stuName = '';
  await fetchGradesBySchool(value);
};

// 年级选择事件处理
const handleGradeChange = async (value: string) => {
  formparams.grade = value;
  formparams.classId = 0;
  formparams.stuName = '';
  await fetchClassesByGrade(formparams.schoolId, value);
  // 默认选中第一个班级
  if (classList.value.length > 0) {
    formparams.classId = classList.value[0].id;
  }
};

const onFinish = async (values: any) => {
  try {
    // 先验证学生是否存在
    const status_id = await getStudentApi({
      class_id: formparams.classId,
      school: formparams.schoolId,
      name: formparams.stuName
    });
    
    if (!status_id.data || status_id.data.length === 0) {
      message.error('未找到该学生信息，请检查姓名是否正确！');
      return;
    }
    
    formparams.role = status_id.data[0].uid;
    console.log('status_id:', status_id);
    
    // 注册用户
    const registerRes = await postUserApi(formparams);
    if (registerRes.code !== 200) {
      message.error(registerRes.message || '注册失败！');
      return;
    }
    
    console.log('注册成功:', registerRes);
    message.success('注册成功！');
    
    // 注册成功后自动登录
    const loginRes = await postUserLogin({
      email: formparams.email,
      password: formparams.password
    });
    
    if (loginRes.code !== 200) {
      message.error('自动登录失败，请手动登录');
      router.push('/user/login');
      return;
    }
    
    localStorage.setItem('token', loginRes.data.token);

    let enrichedUserData = { ...loginRes.data };
    try {
      if (!enrichedUserData.teacher && enrichedUserData.student?.class_id) {
        const { getClassesDetailApi } = await import('@/servers/api/classes');
        const classId = enrichedUserData.student.class_id;
        const r = await getClassesDetailApi(
          { class_id: classId },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        if (r?.code === 200 && r.data?.[0]?.subject_selection) {
          enrichedUserData.student.subject_selection = r.data[0].subject_selection;
        }
      }
    } catch (e) {
      console.warn('获取班级选科信息失败', e);
    }

    userStore.setUserInfo({
      ...enrichedUserData,
      token: enrichedUserData.token
    });
    localStorage.setItem('user', JSON.stringify(userStore.userInfo));
    
    // 进行角色绑定
    const selectedStudent = status_id.data[0];
    
    console.log('选中的学生信息:', selectedStudent);
    
    const bindData: ExtendedBindStatus = {
      id: loginRes.data.id,
      school: formparams.schoolId,
      class_id: String(formparams.classId),
      stuName: formparams.stuName,
      uid: selectedStudent.uid
    };
    
    // 调用角色绑定接口
    const { putUserBindStatus } = await import('@/servers/api/user');
    
    // 使用原有的绑定接口（不包含uid）
    const basicBindData = {
      id: loginRes.data.id,
      school: formparams.schoolId,
      class_id: String(formparams.classId),
      stuName: formparams.stuName
    };
    
    const bindRes = await putUserBindStatus(basicBindData);
    console.log('绑定结果:', bindRes);
    console.log('学生UID:', selectedStudent.uid);
    
    if (bindRes.success || bindRes.code === 200) {
      message.success('注册并绑定成功！');
      
      // 根据用户类型跳转
      const user = userStore.getUserInfo();
      if (user['teacher'] !== undefined) {
        router.push('/teacher_info');
      } else {
        router.push('/grade');
      }
    } else {
      message.error('角色绑定失败，请在个人中心重新绑定');
      router.push('/grade');
    }
  } catch (error) {
    console.error('注册或绑定过程出错:', error);
    message.error('注册失败，请检查输入的信息是否正确');
  }
}

const onFinishFailed = (errorInfo: any) => {
  console.log('Failed:', errorInfo)
  message.error('注册失败！');
}

// 组件挂载时加载学校数据
onMounted(() => {
  loadSchoolData();
});


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h2", null, "账号注册", -1)),
    _createVNode(_component_a_form, {
      model: formparams,
      name: "normal_register",
      class: "register-form",
      onFinish: onFinish,
      onFinishFailed: onFinishFailed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: " 手 机 号 ",
          name: "email",
          rules: [
            { required: true, message: '请输入用户邮箱!' },
            {pattern: /^1[3456789]\d{9}$/,message: '请输入正确的手机号格式'}
            ]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formparams.email,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formparams.email) = $event))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(SafetyOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: " 密 码 ",
          name: "password",
          rules: [{ required: true, message: '请输出密码!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: formparams.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formparams.password) = $event))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(LockOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "昵称",
          name: "name",
          rules: [{ required: true, message: '请输入真实姓名!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formparams.name,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formparams.name) = $event))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(UserOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "所在学校",
          name: "schoolId",
          rules: [{ required: true, message: '请选择学校!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formparams.schoolId,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formparams.schoolId) = $event)),
              onChange: handleSchoolChange,
              style: {"width":"100%"},
              placeholder: "请选择学校",
              loading: _unref(schoolList).length === 0
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolList), (school) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: school.school_id,
                    value: school.school_id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(school.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "所在年级",
          name: "grade",
          rules: [{ required: true, message: '请选择年级!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formparams.grade,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formparams.grade) = $event)),
              onChange: handleGradeChange,
              style: {"width":"100%"},
              placeholder: "请选择年级",
              loading: _unref(gradeList).length === 0 && formparams.schoolId,
              disabled: !formparams.schoolId
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeList), (grade) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: grade,
                    value: grade
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(grade), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "loading", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "所在班级",
          name: "classId",
          rules: [{ required: true, message: '请选择班级!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formparams.classId,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formparams.classId) = $event)),
              style: {"width":"100%"},
              placeholder: "请选择班级",
              loading: _unref(classList).length === 0 && formparams.grade,
              disabled: !formparams.grade
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classList), (cls) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: cls.id,
                    value: cls.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(cls.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "loading", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "学生姓名",
          name: "stuName",
          rules: [{ required: true, message: '请输入学生姓名!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formparams.stuName,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formparams.stuName) = $event)),
              placeholder: "请输入学生姓名"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(UserOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              disabled: disabled.value,
              type: "primary",
              "html-type": "submit",
              class: "login-form-button"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" 注册 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _cache[10] || (_cache[10] = _createTextVNode(" 或者 ", -1)),
            _createVNode(_component_router_link, { to: "/user/login" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("登录", -1)
              ]))]),
              _: 1
            }),
            _cache[11] || (_cache[11] = _createTextVNode(" | ", -1)),
            _createVNode(_component_router_link, { to: "/user/teacher-register" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("教师注册", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})